/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {FlexLayoutModule} from "@angular/flex-layout";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

import {MatFormFieldModule} from "@angular/material/form-field";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {MatIconModule} from "@angular/material/icon";
import {MatDialogModule} from "@angular/material/dialog";
import {MatCardModule} from "@angular/material/card";
import {MatDividerModule} from "@angular/material/divider";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {MatSnackBarModule} from "@angular/material/snack-bar";

import {BaseModule} from "../../platform/base/base.module";

import {AigiaLoginDialogComponent} from "./aigia-login-dialog/aigia-login-dialog.component";
import {AigiaLoginDialogDirective} from "./aigia-login-dialog/aigia-login-dialog.directive";
import {AigiaLoginTotpDialogComponent} from "./aigia-login-totp-dialog/aigia-login-totp-dialog.component";
import {AigiaLoginTotpDialogDirective} from "./aigia-login-totp-dialog/aigia-login-totp-dialog.directive";

import {AigiaLoginQrDialogComponent} from "./aigia-login-qr-dialog/aigia-login-qr-dialog.component";
import {AigiaLoginQrDialogDirective} from "./aigia-login-qr-dialog/aigia-login-qr-dialog.directive";
import {AigiaLogoutDialogComponent} from "./aigia-logout-dialog/aigia-logout-dialog.component";
import {AigiaLogoutDialogDirective} from "./aigia-logout-dialog/aigia-logout-dialog.directive";
import {AigiaPasswordDialogComponent} from "./aigia-password-dialog/aigia-password-dialog.component";
import {AigiaPasswordDialogDirective} from "./aigia-password-dialog/aigia-password-dialog.directive";
import {AigiaRegistDialogComponent} from "./aigia-regist-dialog/aigia-regist-dialog.component";
import {AigiaRegistDialog2Component} from "./aigia-regist-dialog2/aigia-regist-dialog2.component";
import {AigiaRegistDialogDirective} from "./aigia-regist-dialog/aigia-regist-dialog.directive";
import {AigiaRegistDialog2Directive} from "./aigia-regist-dialog2/aigia-regist-dialog2.directive";
import {AigiaPolicyDialogComponent} from "./aigia-policy-dialog/aigia-policy-dialog.component";
import {AigiaPolicyDialogDirective} from "./aigia-policy-dialog/aigia-policy-dialog.directive";
import {AigiaInfoDialogComponent} from "../base/components/aigia-info-dialog/aigia-info-dialog.component";

import {AigiaAuthService} from "./aigia-auth.service";
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
	declarations: [
		AigiaLoginDialogDirective,
		AigiaLoginQrDialogDirective,
		AigiaLoginTotpDialogDirective,
		AigiaRegistDialogDirective,
		AigiaRegistDialog2Directive,

		AigiaPolicyDialogDirective,
		AigiaPasswordDialogDirective,
		AigiaLogoutDialogDirective,
		AigiaLoginDialogComponent,
		AigiaLoginQrDialogComponent,
		AigiaLoginTotpDialogComponent,
		AigiaRegistDialogComponent,
		AigiaRegistDialog2Component,

		AigiaPolicyDialogComponent,
		AigiaInfoDialogComponent,
		AigiaPasswordDialogComponent,
		AigiaLogoutDialogComponent,

	],
	providers: [
		AigiaAuthService,
	],
	imports: [
		CommonModule,
		FormsModule,

		FlexLayoutModule,
		MatDividerModule,
		MatButtonModule,
		MatCheckboxModule,
		MatDialogModule,
		MatIconModule,
		MatInputModule,
		MatSnackBarModule,
		MatFormFieldModule,
		MatSelectModule,
		ReactiveFormsModule,
		BaseModule,
		MatCardModule,
		TranslateModule
	],
	exports: [
		AigiaLoginDialogDirective,
		AigiaLoginQrDialogDirective,
		AigiaLoginTotpDialogDirective,
		AigiaRegistDialogDirective,

		AigiaPolicyDialogDirective,
		AigiaPasswordDialogDirective,
		AigiaLogoutDialogDirective,
		AigiaRegistDialog2Directive,
	],
	bootstrap: [
		AigiaLoginDialogComponent,
		AigiaLoginQrDialogComponent,
		AigiaLoginTotpDialogComponent,
		AigiaRegistDialogComponent,

		AigiaPolicyDialogComponent,
		AigiaPasswordDialogComponent,
		AigiaInfoDialogComponent,
		AigiaLogoutDialogComponent,
	],
})

export class AigiaAuthModule {
}
